const config = {
    api: {
        baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
        timeout: 10000,
    },
    environment: process.env.REACT_APP_ENV || 'development'
};

export default config;